export default __webpack_public_path__ + "static/73-1824cf8761ccfc2a120065723b7227dc.gif";